export var REQUEST_TYPE_POST='POST';export var REQUEST_TYPE_GET='GET';